module.exports = __webpack_public_path__ + "img/swiper-2.bcd48e2.png";